import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

export const Title = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
`
